import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Minus SVG
 *
 * @returns
 */
function MinusSVG({ className, ...rest }: SVGProps) {
	return (
		<svg viewBox="0 0 24 24" className={classnames('roc-icon roc-icon-minus', className)} {...rest}>
			<path d="M18,11 C18.5522847,11 19,11.4477153 19,12 C19,12.5128358 18.6139598,12.9355072 18.1166211,12.9932723 L18,13 L6,13 C5.44771525,13 5,12.5522847 5,12 C5,11.4871642 5.38604019,11.0644928 5.88337887,11.0067277 L6,11 L18,11 Z"></path>
		</svg>
	);
}

export default MinusSVG;
